

// --------------------------------------------------------------------------------------------------------------------
// <copyright file="EntitiesMetadata.js" company="Logic Software">
//   (c) Logic Software
// </copyright>
// <summary>
//   Generated class for entities.
//   !!!DO NOT CHANGE IT DIRECTLY!!!
// </summary>
// --------------------------------------------------------------------------------------------------------------------

let metadata = {
    Account: {
        fields: {
            Id: 'Account_Id',
            Name: 'Account_Name',
            IsInitialized: 'Account_IsInitialized',
            IsRemoved: 'Account_IsRemoved',
        },
    },
    ACProjectAggregatedValues: {
        fields: {
            ProjectAggregatedValues_Project_ProjectID: 'ACProjectAggregatedValues_ProjectAggregatedValues_Project_ProjectID',
            ActualHours: 'ACProjectAggregatedValues_ActualHours',
            Budget: 'ACProjectAggregatedValues_Budget',
            EstimatedHours: 'ACProjectAggregatedValues_EstimatedHours',
            ChildsBudget: 'ACProjectAggregatedValues_ChildsBudget',
            ChildsEstimatedHours: 'ACProjectAggregatedValues_ChildsEstimatedHours',
            Cost: 'ACProjectAggregatedValues_Cost',
            InternalCost: 'ACProjectAggregatedValues_InternalCost',
            CostVariance: 'ACProjectAggregatedValues_CostVariance',
            BudgetedCost: 'ACProjectAggregatedValues_BudgetedCost',
            Profit: 'ACProjectAggregatedValues_Profit',
            PlannedExpenses: 'ACProjectAggregatedValues_PlannedExpenses',
            ProfitHealth: 'ACProjectAggregatedValues_ProfitHealth',
            Profitability: 'ACProjectAggregatedValues_Profitability',
        },
    },
    ACTaskAggregatedValues: {
        fields: {
            TaskAggregatedValues_Task_TaskID: 'ACTaskAggregatedValues_TaskAggregatedValues_Task_TaskID',
            ActualHours: 'ACTaskAggregatedValues_ActualHours',
            Budget: 'ACTaskAggregatedValues_Budget',
            EstimatedHours: 'ACTaskAggregatedValues_EstimatedHours',
            ChildsActualHours: 'ACTaskAggregatedValues_ChildsActualHours',
            ChildsBudget: 'ACTaskAggregatedValues_ChildsBudget',
            ChildsEstimatedHours: 'ACTaskAggregatedValues_ChildsEstimatedHours',
            OwnEstimatedHours: 'ACTaskAggregatedValues_OwnEstimatedHours',
            Cost: 'ACTaskAggregatedValues_Cost',
            OwnCost: 'ACTaskAggregatedValues_OwnCost',
            InternalCost: 'ACTaskAggregatedValues_InternalCost',
            CostVariance: 'ACTaskAggregatedValues_CostVariance',
            Profit: 'ACTaskAggregatedValues_Profit',
            ProfitHealth: 'ACTaskAggregatedValues_ProfitHealth',
            OwnEstimatedCost: 'ACTaskAggregatedValues_OwnEstimatedCost',
            EstimatedCost: 'ACTaskAggregatedValues_EstimatedCost',
        },
    },
    ACTaskHealth: {
        fields: {
            TaskAggregatedValues_Task_TaskID: 'ACTaskHealth_TaskAggregatedValues_Task_TaskID',
            Health: 'ACTaskHealth_Health',
        },
    },
    AppEntity: {
        fields: {
            EntityID: 'AppEntity_EntityID',
            DisplayName: 'AppEntity_DisplayName',
            HasStatus: 'AppEntity_HasStatus',
            Order: 'AppEntity_Order',
            TaskTypeID: 'AppEntity_TaskTypeID',
        },
        DisplayNameMaxLength: 50,
    },
    Approval: {
        fields: {
            ApprovalId: 'Approval_ApprovalId',
            IsActive: 'Approval_IsActive',
        },
    },
    ApprovalHistory: {
        fields: {
            HistoryId: 'ApprovalHistory_HistoryId',
            History: 'ApprovalHistory_History',
        },
    },
    Approver: {
        fields: {
            ApproverId: 'Approver_ApproverId',
            IsCreator: 'Approver_IsCreator',
            IsInterested: 'Approver_IsInterested',
            Status: 'Approver_Status',
            LastActivityDate: 'Approver_LastActivityDate',
        },
    },
    Attachment: {
        fields: {
            AttachmentID: 'Attachment_AttachmentID',
            FileName: 'Attachment_FileName',
            RelativePath: 'Attachment_RelativePath',
            FileType: 'Attachment_FileType',
            FileLength: 'Attachment_FileLength',
            FileContents: 'Attachment_FileContents',
            Version: 'Attachment_Version',
            CreationDate: 'Attachment_CreationDate',
            CanHaveThumbnail: 'Attachment_CanHaveThumbnail',
            HasThumbnail: 'Attachment_HasThumbnail',
            ThumbnailContents: 'Attachment_ThumbnailContents',
            ExternalLink: 'Attachment_ExternalLink',
        },
        RelativePathMaxLength: 1000000,
    },
    AttachmentSaveModes: {
        fields: {
            AttachmentSaveModeID: 'AttachmentSaveModes_AttachmentSaveModeID',
            Description: 'AttachmentSaveModes_Description',
        },
    },
    AvailableStatusesSettings: {
        fields: {
            ID: 'AvailableStatusesSettings_ID',
            WorkflowStatusType: 'AvailableStatusesSettings_WorkflowStatusType',
        },
    },
    BannedEmail: {
        fields: {
            Id: 'BannedEmail_Id',
            Value: 'BannedEmail_Value',
            IsRegex: 'BannedEmail_IsRegex',
        },
    },
    CalendarEvent: {
        fields: {
            CalendarEventID: 'CalendarEvent_CalendarEventID',
            TaskEventID: 'CalendarEvent_TaskEventID',
            CreatorID: 'CalendarEvent_CreatorID',
            Name: 'CalendarEvent_Name',
            StartDate: 'CalendarEvent_StartDate',
            EndDate: 'CalendarEvent_EndDate',
            CalendarEventType: 'CalendarEvent_CalendarEventType',
            VacationUserName: 'CalendarEvent_VacationUserName',
            VacationUserID: 'CalendarEvent_VacationUserID',
            IsHalfDayVacation: 'CalendarEvent_IsHalfDayVacation',
        },
    },
    CalendarMessage: {
        fields: {
            ID: 'CalendarMessage_ID',
            Summary: 'CalendarMessage_Summary',
            ProjectID: 'CalendarMessage_ProjectID',
            ProjectName: 'CalendarMessage_ProjectName',
            StartDate: 'CalendarMessage_StartDate',
            EndDate: 'CalendarMessage_EndDate',
            Type: 'CalendarMessage_Type',
            IsStartDate: 'CalendarMessage_IsStartDate',
            Description: 'CalendarMessage_Description',
            ProjectDescription: 'CalendarMessage_ProjectDescription',
        },
    },
    Category: {
        fields: {
            CategoryID: 'Category_CategoryID',
            Name: 'Category_Name',
        },
        NameMaxLength: 255,
    },
    ClientsPortalEvents: {
        fields: {
            RowIndex: 'ClientsPortalEvents_RowIndex',
            UserID: 'ClientsPortalEvents_UserID',
            EventOwnerID: 'ClientsPortalEvents_EventOwnerID',
            ActivityName: 'ClientsPortalEvents_ActivityName',
            ProjectName: 'ClientsPortalEvents_ProjectName',
            EventType: 'ClientsPortalEvents_EventType',
            ProjectID: 'ClientsPortalEvents_ProjectID',
            ActivityID: 'ClientsPortalEvents_ActivityID',
            AssigneeUserID: 'ClientsPortalEvents_AssigneeUserID',
            EventDate: 'ClientsPortalEvents_EventDate',
            ActivityStatus: 'ClientsPortalEvents_ActivityStatus',
            ActivityIsCompleted: 'ClientsPortalEvents_ActivityIsCompleted',
            ActivityTypeID: 'ClientsPortalEvents_ActivityTypeID',
            EventOwnerName: 'ClientsPortalEvents_EventOwnerName',
            AttachmentID: 'ClientsPortalEvents_AttachmentID',
            AttachmentName: 'ClientsPortalEvents_AttachmentName',
            AttachmentDescription: 'ClientsPortalEvents_AttachmentDescription',
            MessageText: 'ClientsPortalEvents_MessageText',
            FileVersion: 'ClientsPortalEvents_FileVersion',
        },
    },
    CriticalTask: {
        fields: {
            ProjectID: 'CriticalTask_ProjectID',
        },
    },
    CurrentUserApproval: {
        fields: {
            UserID: 'CurrentUserApproval_UserID',
            ProjectID: 'CurrentUserApproval_ProjectID',
            TaskID: 'CurrentUserApproval_TaskID',
            ProjectName: 'CurrentUserApproval_ProjectName',
            TaskName: 'CurrentUserApproval_TaskName',
            LastModificationDate: 'CurrentUserApproval_LastModificationDate',
            IsNew: 'CurrentUserApproval_IsNew',
            IsCreator: 'CurrentUserApproval_IsCreator',
            Status: 'CurrentUserApproval_Status',
        },
    },
    CurrentUserApprovalInfo: {
        fields: {
            UserID: 'CurrentUserApprovalInfo_UserID',
            IsInterested: 'CurrentUserApprovalInfo_IsInterested',
            NewCount: 'CurrentUserApprovalInfo_NewCount',
        },
    },
    CurrentUserTaskAssignee: {
        fields: {
            TaskAssigneeID: 'CurrentUserTaskAssignee_TaskAssigneeID',
            WorkIsDone: 'CurrentUserTaskAssignee_WorkIsDone',
            PersonalHoursLeft: 'CurrentUserTaskAssignee_PersonalHoursLeft',
            PersonalEstimatedHours: 'CurrentUserTaskAssignee_PersonalEstimatedHours',
            WorkIsDoneSetDate: 'CurrentUserTaskAssignee_WorkIsDoneSetDate',
        },
    },
    Customer: {
        fields: {
            CustomerID: 'Customer_CustomerID',
            Name: 'Customer_Name',
            Enabled: 'Customer_Enabled',
            Description: 'Customer_Description',
            Address1: 'Customer_Address1',
            Address2: 'Customer_Address2',
            City: 'Customer_City',
            State: 'Customer_State',
            Country: 'Customer_Country',
            PostalCode: 'Customer_PostalCode',
            Phone1: 'Customer_Phone1',
            Phone2: 'Customer_Phone2',
            Fax: 'Customer_Fax',
            HourlyRate: 'Customer_HourlyRate',
            LastModificationDate: 'Customer_LastModificationDate',
        },
        NameMaxLength: 100,
        DescriptionMaxLength: 2000,
        Address1MaxLength: 255,
        Address2MaxLength: 255,
        CityMaxLength: 50,
        StateMaxLength: 50,
        CountryMaxLength: 50,
        PostalCodeMaxLength: 50,
        Phone1MaxLength: 50,
        Phone2MaxLength: 50,
        FaxMaxLength: 50,
        HourlyRateMaxValue: 99999999,
        HourlyRateMinValue: 0,
    },
    CustomField: {
        fields: {
            FieldID: 'CustomField_FieldID',
            FieldName: 'CustomField_FieldName',
            DisplayName: 'CustomField_DisplayName',
            FieldDataTypeName: 'CustomField_FieldDataTypeName',
            FieldIndex: 'CustomField_FieldIndex',
            IsRequired: 'CustomField_IsRequired',
            IsRestricted: 'CustomField_IsRestricted',
            Order: 'CustomField_Order',
            Description: 'CustomField_Description',
            IsNumeric: 'CustomField_IsNumeric',
            IsIdentity: 'CustomField_IsIdentity',
            CurrentIdentity: 'CustomField_CurrentIdentity',
        },
        DisplayNameMaxLength: 50,
        FieldDataTypeNameMaxLength: 50,
        DescriptionMaxLength: 400,
    },
    CustomFieldCondition: {
        fields: {
            RowIndex: 'CustomFieldCondition_RowIndex',
            FieldID: 'CustomFieldCondition_FieldID',
            FieldName: 'CustomFieldCondition_FieldName',
            DisplayName: 'CustomFieldCondition_DisplayName',
            IsRequired: 'CustomFieldCondition_IsRequired',
            IsRestricted: 'CustomFieldCondition_IsRestricted',
            FieldValueID: 'CustomFieldCondition_FieldValueID',
            Value: 'CustomFieldCondition_Value',
            FieldDataTypeID: 'CustomFieldCondition_FieldDataTypeID',
            EntityID: 'CustomFieldCondition_EntityID',
        },
        DisplayNameMaxLength: 50,
    },
    CustomFieldDataType: {
        fields: {
            FieldDataTypeID: 'CustomFieldDataType_FieldDataTypeID',
            DisplayName: 'CustomFieldDataType_DisplayName',
        },
        DisplayNameMaxLength: 50,
    },
    CustomFieldOrder: {
        fields: {
            FieldID: 'CustomFieldOrder_FieldID',
            Order: 'CustomFieldOrder_Order',
        },
    },
    CustomFieldRestriction: {
        fields: {
            FieldRestrictionID: 'CustomFieldRestriction_FieldRestrictionID',
        },
    },
    CustomFieldValue: {
        fields: {
            FieldValueID: 'CustomFieldValue_FieldValueID',
            Value: 'CustomFieldValue_Value',
            Order: 'CustomFieldValue_Order',
        },
    },
    Customization: {
        fields: {
            AccountID: 'Customization_AccountID',
            CustomizationKey: 'Customization_CustomizationKey',
            Data: 'Customization_Data',
        },
    },
    DefaultNotificationTemplate: {
        fields: {
            DefaultTemplateID: 'DefaultNotificationTemplate_DefaultTemplateID',
            Name: 'DefaultNotificationTemplate_Name',
            DisplayName: 'DefaultNotificationTemplate_DisplayName',
            Transformation: 'DefaultNotificationTemplate_Transformation',
            RazorTemplate: 'DefaultNotificationTemplate_RazorTemplate',
        },
        NameMaxLength: 50,
        DisplayNameMaxLength: 50,
    },
    DefaultRecipientsForProjectMessage: {
        fields: {
            UserID: 'DefaultRecipientsForProjectMessage_UserID',
        },
    },
    DefaultRecipientsForTaskMessage: {
        fields: {
            UserID: 'DefaultRecipientsForTaskMessage_UserID',
        },
    },
    DispatcherReportEntity: {
        fields: {
            UserID: 'DispatcherReportEntity_UserID',
            PlannedHours: 'DispatcherReportEntity_PlannedHours',
            DateEntry: 'DispatcherReportEntity_DateEntry',
        },
    },
    DispatcherVacationsReportEntity: {
        fields: {
            UserID: 'DispatcherVacationsReportEntity_UserID',
            UserName: 'DispatcherVacationsReportEntity_UserName',
            Hours: 'DispatcherVacationsReportEntity_Hours',
            DateEntry: 'DispatcherVacationsReportEntity_DateEntry',
        },
    },
    EstimatedHoursForPeriodOfDateEntity: {
        fields: {
            EstimatedHoursForPeriodOfDateEntity_TaskID: 'EstimatedHoursForPeriodOfDateEntity_EstimatedHoursForPeriodOfDateEntity_TaskID',
            PlannedHours: 'EstimatedHoursForPeriodOfDateEntity_PlannedHours',
        },
    },
    EventLog: {
        fields: {
            EntryID: 'EventLog_EntryID',
            EntryDate: 'EventLog_EntryDate',
            Category: 'EventLog_Category',
            EventType: 'EventLog_EventType',
            Title: 'EventLog_Title',
            Message: 'EventLog_Message',
        },
        MessageMaxLength: 1000000,
    },
    FilterEntity: {
        fields: {
            FilterID: 'FilterEntity_FilterID',
            Name: 'FilterEntity_Name',
            FilterXML: 'FilterEntity_FilterXML',
            IsShared: 'FilterEntity_IsShared',
        },
        NameMaxLength: 400,
        FilterXMLMaxLength: 1000000,
    },
    Follower: {
        fields: {
            FollowerID: 'Follower_FollowerID',
        },
    },
    Form: {
        fields: {
            FormID: 'Form_FormID',
            Title: 'Form_Title',
            Description: 'Form_Description',
            Status: 'Form_Status',
            DateCreated: 'Form_DateCreated',
            DateEdited: 'Form_DateEdited',
            AnonymousAccess: 'Form_AnonymousAccess',
            GuestAccess: 'Form_GuestAccess',
            Layout: 'Form_Layout',
            ProjectConversion: 'Form_ProjectConversion',
            TaskConversion: 'Form_TaskConversion',
            RequestConversion: 'Form_RequestConversion',
            IssueConversion: 'Form_IssueConversion',
            NotifyRecordCreator: 'Form_NotifyRecordCreator',
            NotifyOnEmailFieldId: 'Form_NotifyOnEmailFieldId',
            AutoConvertCreatorID: 'Form_AutoConvertCreatorID',
            AutoConvertFor: 'Form_AutoConvertFor',
        },
        TitleMaxLength: 1000000,
        DescriptionMaxLength: 1000000,
    },
    FormAttachment: {
        fields: {
            FormAttachmentID: 'FormAttachment_FormAttachmentID',
            FormRecordID: 'FormAttachment_FormRecordID',
            FileName: 'FormAttachment_FileName',
            RelativePath: 'FormAttachment_RelativePath',
            FileType: 'FormAttachment_FileType',
            FileLength: 'FormAttachment_FileLength',
            FileContents: 'FormAttachment_FileContents',
            FormID: 'FormAttachment_FormID',
            CanHaveThumbnail: 'FormAttachment_CanHaveThumbnail',
            HasThumbnail: 'FormAttachment_HasThumbnail',
            ThumbnailContents: 'FormAttachment_ThumbnailContents',
        },
        RelativePathMaxLength: 1000000,
    },
    FormPermissionsEntry: {
        fields: {
            FormPermissionID: 'FormPermissionsEntry_FormPermissionID',
            FormID: 'FormPermissionsEntry_FormID',
            UserID: 'FormPermissionsEntry_UserID',
            TeamID: 'FormPermissionsEntry_TeamID',
            CanAddRecords: 'FormPermissionsEntry_CanAddRecords',
            CanViewRecords: 'FormPermissionsEntry_CanViewRecords',
            CanManageRecords: 'FormPermissionsEntry_CanManageRecords',
            CanManageForm: 'FormPermissionsEntry_CanManageForm',
            CanReceiveNotifications: 'FormPermissionsEntry_CanReceiveNotifications',
        },
    },
    FormRecord: {
        fields: {
            RecordID: 'FormRecord_RecordID',
            Title: 'FormRecord_Title',
            Keywords: 'FormRecord_Keywords',
            CreationDate: 'FormRecord_CreationDate',
            EditedDate: 'FormRecord_EditedDate',
            Data: 'FormRecord_Data',
            IsUnread: 'FormRecord_IsUnread',
            IsConverted: 'FormRecord_IsConverted',
            NeedAutoConvert: 'FormRecord_NeedAutoConvert',
            RetryCount: 'FormRecord_RetryCount',
        },
        TitleMaxLength: 1000000,
        KeywordsMaxLength: 1000000,
    },
    FormRecordConversion: {
        fields: {
            RecordConversionID: 'FormRecordConversion_RecordConversionID',
            RecordID: 'FormRecordConversion_RecordID',
            TaskID: 'FormRecordConversion_TaskID',
            ProjectID: 'FormRecordConversion_ProjectID',
        },
    },
    FormRecordForAutoConversionView: {
        fields: {
            AccountId: 'FormRecordForAutoConversionView_AccountId',
            RecordID: 'FormRecordForAutoConversionView_RecordID',
            Title: 'FormRecordForAutoConversionView_Title',
            Keywords: 'FormRecordForAutoConversionView_Keywords',
            CreationDate: 'FormRecordForAutoConversionView_CreationDate',
            EditedDate: 'FormRecordForAutoConversionView_EditedDate',
            Data: 'FormRecordForAutoConversionView_Data',
            IsConverted: 'FormRecordForAutoConversionView_IsConverted',
            NeedAutoConvert: 'FormRecordForAutoConversionView_NeedAutoConvert',
            RetryCount: 'FormRecordForAutoConversionView_RetryCount',
        },
        TitleMaxLength: 1000000,
        KeywordsMaxLength: 1000000,
    },
    FormRecordNotificationEventsView: {
        fields: {
            AccountID: 'FormRecordNotificationEventsView_AccountID',
            FormRecordRecipientID: 'FormRecordNotificationEventsView_FormRecordRecipientID',
            UserID: 'FormRecordNotificationEventsView_UserID',
            UserTimeZoneOffset: 'FormRecordNotificationEventsView_UserTimeZoneOffset',
            Email: 'FormRecordNotificationEventsView_Email',
            NotificationEventID: 'FormRecordNotificationEventsView_NotificationEventID',
            EventDate: 'FormRecordNotificationEventsView_EventDate',
            Entity: 'FormRecordNotificationEventsView_Entity',
            ObjectID: 'FormRecordNotificationEventsView_ObjectID',
            AuthorID: 'FormRecordNotificationEventsView_AuthorID',
            Operation: 'FormRecordNotificationEventsView_Operation',
            ChangeSet: 'FormRecordNotificationEventsView_ChangeSet',
            DeleteSet: 'FormRecordNotificationEventsView_DeleteSet',
            DataSet: 'FormRecordNotificationEventsView_DataSet',
            Template: 'FormRecordNotificationEventsView_Template',
        },
    },
    FormRecordRead: {
        fields: {
            RecordReadID: 'FormRecordRead_RecordReadID',
            UserID: 'FormRecordRead_UserID',
            RecordID: 'FormRecordRead_RecordID',
        },
    },
    FormRecordRecipient: {
        fields: {
            FormRecordRecipientID: 'FormRecordRecipient_FormRecordRecipientID',
            NotificationEventID: 'FormRecordRecipient_NotificationEventID',
            UserID: 'FormRecordRecipient_UserID',
            Email: 'FormRecordRecipient_Email',
        },
    },
    GCByUsersEntity: {
        fields: {
            MilestoneName: 'GCByUsersEntity_MilestoneName',
            MilestoneID: 'GCByUsersEntity_MilestoneID',
            Task_StartDate: 'GCByUsersEntity_Task_StartDate',
            Project_ProjectID: 'GCByUsersEntity_Project_ProjectID',
            Task_EndDate: 'GCByUsersEntity_Task_EndDate',
            Task_Name: 'GCByUsersEntity_Task_Name',
            Task_TaskID: 'GCByUsersEntity_Task_TaskID',
            Task_ParentID: 'GCByUsersEntity_Task_ParentID',
            Task_IsMilestone: 'GCByUsersEntity_Task_IsMilestone',
            Project_Name: 'GCByUsersEntity_Project_Name',
            Task_ProjectID: 'GCByUsersEntity_Task_ProjectID',
            Task_Progress: 'GCByUsersEntity_Task_Progress',
            Task_IsCriticalPath: 'GCByUsersEntity_Task_IsCriticalPath',
            Task_HasChilds: 'GCByUsersEntity_Task_HasChilds',
            UserID: 'GCByUsersEntity_UserID',
            Task_WBSNumber: 'GCByUsersEntity_Task_WBSNumber',
        },
    },
    HierarchyItemFilteredDescendant: {
        fields: {
            AncestorID: 'HierarchyItemFilteredDescendant_AncestorID',
            AncestorProjectID: 'HierarchyItemFilteredDescendant_AncestorProjectID',
            DescendantID: 'HierarchyItemFilteredDescendant_DescendantID',
            IsEqualToAncestor: 'HierarchyItemFilteredDescendant_IsEqualToAncestor',
        },
    },
    IssueByEmailOptions: {
        fields: {
            OptionsID: 'IssueByEmailOptions_OptionsID',
            AccountID: 'IssueByEmailOptions_AccountID',
            EnableIssueByMail: 'IssueByEmailOptions_EnableIssueByMail',
            Pop3Server: 'IssueByEmailOptions_Pop3Server',
            Pop3Port: 'IssueByEmailOptions_Pop3Port',
            Pop3UserName: 'IssueByEmailOptions_Pop3UserName',
            Pop3Password: 'IssueByEmailOptions_Pop3Password',
            DeleteLetters: 'IssueByEmailOptions_DeleteLetters',
            Pop3EnableSSL: 'IssueByEmailOptions_Pop3EnableSSL',
        },
        Pop3ServerMaxLength: 50,
        Pop3PortMaxValue: 65535,
        Pop3PortMinValue: 0,
        Pop3UserNameMaxLength: 50,
        Pop3PasswordMaxLength: 50,
    },
    License: {
        fields: {
            LicenseID: 'License_LicenseID',
            LicenseBody: 'License_LicenseBody',
            CreationDate: 'License_CreationDate',
        },
        LicenseBodyMaxLength: 1000000,
    },
    LightweightTimeEntry: {
        fields: {
            TimeEntryID: 'LightweightTimeEntry_TimeEntryID',
            EntryDate: 'LightweightTimeEntry_EntryDate',
            Duration: 'LightweightTimeEntry_Duration',
        },
        DurationMaxValue: 99.99,
        DurationMinValue: 0.01,
    },
    MasterTasksListHierarchy: {
        fields: {
            Task_TaskID: 'MasterTasksListHierarchy_Task_TaskID',
            Task_Name: 'MasterTasksListHierarchy_Task_Name',
            Task_ProjectID: 'MasterTasksListHierarchy_Task_ProjectID',
            Task_ParentID: 'MasterTasksListHierarchy_Task_ParentID',
            Type: 'MasterTasksListHierarchy_Type',
            Delay: 'MasterTasksListHierarchy_Delay',
            IsChecked: 'MasterTasksListHierarchy_IsChecked',
        },
    },
    MemberPermission: {
        fields: {
            MemberPermissionID: 'MemberPermission_MemberPermissionID',
            CanAccessAllTasks: 'MemberPermission_CanAccessAllTasks',
            CanAccessAllTimeEntries: 'MemberPermission_CanAccessAllTimeEntries',
            CanEditProject: 'MemberPermission_CanEditProject',
            CanEditAllTasks: 'MemberPermission_CanEditAllTasks',
            CanEditAssignedTasks: 'MemberPermission_CanEditAssignedTasks',
            CanEditAllTimeEntries: 'MemberPermission_CanEditAllTimeEntries',
            CanCreateTasks: 'MemberPermission_CanCreateTasks',
            CanCreateTimeEntries: 'MemberPermission_CanCreateTimeEntries',
            CanCreateTimeEntriesForOther: 'MemberPermission_CanCreateTimeEntriesForOther',
            CanDeleteProject: 'MemberPermission_CanDeleteProject',
            CanDeleteAllTasks: 'MemberPermission_CanDeleteAllTasks',
            CanDeleteAllTimeEntries: 'MemberPermission_CanDeleteAllTimeEntries',
            CanManageAssigneesTasks: 'MemberPermission_CanManageAssigneesTasks',
            CanViewMembersAndAssignees: 'MemberPermission_CanViewMembersAndAssignees',
            CanManageProjectMembers: 'MemberPermission_CanManageProjectMembers',
            CanManage: 'MemberPermission_CanManage',
        },
    },
    Message: {
        fields: {
            MessageID: 'Message_MessageID',
            PostDate: 'Message_PostDate',
            MessageText: 'Message_MessageText',
            EditedAt: 'Message_EditedAt',
            EditedByName: 'Message_EditedByName',
            EditedByUserID: 'Message_EditedByUserID',
        },
        MessageTextMaxLength: 10000,
    },
    MessageBoardOptions: {
        fields: {
            ID: 'MessageBoardOptions_ID',
            TimeVisit: 'MessageBoardOptions_TimeVisit',
            EventsVisible: 'MessageBoardOptions_EventsVisible',
            MessagesVisible: 'MessageBoardOptions_MessagesVisible',
            FilesVisible: 'MessageBoardOptions_FilesVisible',
            SeenPostsCount: 'MessageBoardOptions_SeenPostsCount',
        },
    },
    MessageNotificationRecipient: {
        fields: {
            MessageNotificationRecipientsID: 'MessageNotificationRecipient_MessageNotificationRecipientsID',
            MessageID: 'MessageNotificationRecipient_MessageID',
            UserID: 'MessageNotificationRecipient_UserID',
        },
    },
    Notification: {
        fields: {
            NotificationID: 'Notification_NotificationID',
            Name: 'Notification_Name',
            IsSystem: 'Notification_IsSystem',
            Recipients: 'Notification_Recipients',
            NotifyCreator: 'Notification_NotifyCreator',
            NotifyWhoMadeChange: 'Notification_NotifyWhoMadeChange',
            EventTaskAdd: 'Notification_EventTaskAdd',
            EventTaskEdit: 'Notification_EventTaskEdit',
            EventTaskAssign: 'Notification_EventTaskAssign',
            EventTaskComplete: 'Notification_EventTaskComplete',
            EventTaskDelete: 'Notification_EventTaskDelete',
            EventTaskLate: 'Notification_EventTaskLate',
            EventIssueAdd: 'Notification_EventIssueAdd',
            EventIssueEdit: 'Notification_EventIssueEdit',
            EventIssueAssign: 'Notification_EventIssueAssign',
            EventIssueComplete: 'Notification_EventIssueComplete',
            EventIssueDelete: 'Notification_EventIssueDelete',
            EventIssueLate: 'Notification_EventIssueLate',
            EventRequestAdd: 'Notification_EventRequestAdd',
            EventRequestEdit: 'Notification_EventRequestEdit',
            EventRequestAssign: 'Notification_EventRequestAssign',
            EventRequestComplete: 'Notification_EventRequestComplete',
            EventRequestDelete: 'Notification_EventRequestDelete',
            EventRequestLate: 'Notification_EventRequestLate',
            EventMessageAdd: 'Notification_EventMessageAdd',
            EventTaskCanStart: 'Notification_EventTaskCanStart',
            EventIssueCanStart: 'Notification_EventIssueCanStart',
            EventRequestCanStart: 'Notification_EventRequestCanStart',
        },
        NameMaxLength: 50,
    },
    NotificationEvent: {
        fields: {
            NotificationEventID: 'NotificationEvent_NotificationEventID',
            EventDate: 'NotificationEvent_EventDate',
            Entity: 'NotificationEvent_Entity',
            ProjectID: 'NotificationEvent_ProjectID',
            TaskID: 'NotificationEvent_TaskID',
            ObjectID: 'NotificationEvent_ObjectID',
            AuthorID: 'NotificationEvent_AuthorID',
            Operation: 'NotificationEvent_Operation',
            ChangeSet: 'NotificationEvent_ChangeSet',
            DeleteSet: 'NotificationEvent_DeleteSet',
            DataSet: 'NotificationEvent_DataSet',
        },
    },
    NotificationEventRecipient: {
        fields: {
            ID: 'NotificationEventRecipient_ID',
            EventRecipientStatus: 'NotificationEventRecipient_EventRecipientStatus',
        },
    },
    NotificationFeedItem: {
        fields: {
            Id: 'NotificationFeedItem_Id',
            Type: 'NotificationFeedItem_Type',
            Date: 'NotificationFeedItem_Date',
            Payload: 'NotificationFeedItem_Payload',
        },
    },
    NotificationFeedItemUser: {
        fields: {
            Id: 'NotificationFeedItemUser_Id',
        },
    },
    NotificationTemplate: {
        fields: {
            TemplateID: 'NotificationTemplate_TemplateID',
            Transformation: 'NotificationTemplate_Transformation',
        },
    },
    NotificationUser: {
        fields: {
            NotificationUserID: 'NotificationUser_NotificationUserID',
        },
    },
    NotificationUserOptions: {
        fields: {
            NotificationUserOptionID: 'NotificationUserOptions_NotificationUserOptionID',
            Enabled: 'NotificationUserOptions_Enabled',
            CombineNotificationsEnabled: 'NotificationUserOptions_CombineNotificationsEnabled',
            SendInterval: 'NotificationUserOptions_SendInterval',
            DueSendEnabled: 'NotificationUserOptions_DueSendEnabled',
            DueSendInterval: 'NotificationUserOptions_DueSendInterval',
            ActivityListSendEnabled: 'NotificationUserOptions_ActivityListSendEnabled',
            ActivityListSendDay: 'NotificationUserOptions_ActivityListSendDay',
            ActivityListSendTime: 'NotificationUserOptions_ActivityListSendTime',
            LastEventsSendDate: 'NotificationUserOptions_LastEventsSendDate',
            LastLateSendDate: 'NotificationUserOptions_LastLateSendDate',
            LastActivityListSendDate: 'NotificationUserOptions_LastActivityListSendDate',
            LastDueSendDate: 'NotificationUserOptions_LastDueSendDate',
            FollowEvents: 'NotificationUserOptions_FollowEvents',
        },
        SendIntervalMaxValue: 24,
        SendIntervalMinValue: 1,
        DueSendIntervalMaxValue: 7,
        DueSendIntervalMinValue: 1,
        ActivityListSendTimeMaxValue: 24,
        ActivityListSendTimeMinValue: 0,
    },
    OAuthAuthorizationCode: {
        fields: {
            Id: 'OAuthAuthorizationCode_Id',
            Token: 'OAuthAuthorizationCode_Token',
            ExpiresUtc: 'OAuthAuthorizationCode_ExpiresUtc',
            Ticket: 'OAuthAuthorizationCode_Ticket',
        },
    },
    OAuthClient: {
        fields: {
            Id: 'OAuthClient_Id',
            ClientId: 'OAuthClient_ClientId',
            ClientSecret: 'OAuthClient_ClientSecret',
            ClientSecretSalt: 'OAuthClient_ClientSecretSalt',
            RedirectUrls: 'OAuthClient_RedirectUrls',
            ClientName: 'OAuthClient_ClientName',
            IsClientCredsGrant: 'OAuthClient_IsClientCredsGrant',
            AllowedScopes: 'OAuthClient_AllowedScopes',
        },
    },
    OAuthRefreshToken: {
        fields: {
            UserID: 'OAuthRefreshToken_UserID',
            UserAgentHash: 'OAuthRefreshToken_UserAgentHash',
            Token: 'OAuthRefreshToken_Token',
            UserAgent: 'OAuthRefreshToken_UserAgent',
            ClientId: 'OAuthRefreshToken_ClientId',
            ExpiresUtc: 'OAuthRefreshToken_ExpiresUtc',
            Ticket: 'OAuthRefreshToken_Ticket',
        },
    },
    Options: {
        fields: {
            OptionsID: 'Options_OptionsID',
            AccountID: 'Options_AccountID',
            CompanyLogo: 'Options_CompanyLogo',
            WeekendsAsWorkdays: 'Options_WeekendsAsWorkdays',
            EnableNotifications: 'Options_EnableNotifications',
            MailFromName: 'Options_MailFromName',
            MailFromAddress: 'Options_MailFromAddress',
            SmtpServer: 'Options_SmtpServer',
            SmtpPort: 'Options_SmtpPort',
            SmtpUserName: 'Options_SmtpUserName',
            SmtpPassword: 'Options_SmtpPassword',
            EnableIssueByMail: 'Options_EnableIssueByMail',
            Pop3Server: 'Options_Pop3Server',
            Pop3Port: 'Options_Pop3Port',
            Pop3EnableSSL: 'Options_Pop3EnableSSL',
            Pop3UserName: 'Options_Pop3UserName',
            Pop3Password: 'Options_Pop3Password',
            DeleteLetters: 'Options_DeleteLetters',
            EnableSSL: 'Options_EnableSSL',
            NotifyCreator: 'Options_NotifyCreator',
            NotifyAssignees: 'Options_NotifyAssignees',
            NotifyEventEdit: 'Options_NotifyEventEdit',
            NotifyEventAssign: 'Options_NotifyEventAssign',
            NotifyEventDelete: 'Options_NotifyEventDelete',
            NotifyProjectManagersVacationChanged: 'Options_NotifyProjectManagersVacationChanged',
            PasswordHashKey: 'Options_PasswordHashKey',
            ShowPortfolios: 'Options_ShowPortfolios',
            EnableApproveWorkflow: 'Options_EnableApproveWorkflow',
            CreatorAsApprover: 'Options_CreatorAsApprover',
            PMAsApprover: 'Options_PMAsApprover',
            NumberOfHoursPerDay: 'Options_NumberOfHoursPerDay',
            SPIThreshold: 'Options_SPIThreshold',
            CPIThreshold: 'Options_CPIThreshold',
            VacationYearStartDate: 'Options_VacationYearStartDate',
            CNRAvailable: 'Options_CNRAvailable',
            EnforceProhibitedWordsPolicy: 'Options_EnforceProhibitedWordsPolicy',
            PasswordLength: 'Options_PasswordLength',
            PasswordNumbersCount: 'Options_PasswordNumbersCount',
            PasswordSpecSymbolsCount: 'Options_PasswordSpecSymbolsCount',
            LockOutUserAfterInvalidPassword: 'Options_LockOutUserAfterInvalidPassword',
            InvalidPasswordAttempts: 'Options_InvalidPasswordAttempts',
            UnblockOnRecovery: 'Options_UnblockOnRecovery',
            UnblockAutomatically: 'Options_UnblockAutomatically',
            UnblockAutomaticallyIn: 'Options_UnblockAutomaticallyIn',
            LockoutUserDueToInactivity: 'Options_LockoutUserDueToInactivity',
            MaxUserInactivity: 'Options_MaxUserInactivity',
            EnablePasswordExpiration: 'Options_EnablePasswordExpiration',
            PasswordExpiration: 'Options_PasswordExpiration',
            ReportRowsLimit: 'Options_ReportRowsLimit',
            LastActivity: 'Options_LastActivity',
            SecondLoginFlag: 'Options_SecondLoginFlag',
            AvatarsVersion: 'Options_AvatarsVersion',
            CreatorHasFullAccessToProject: 'Options_CreatorHasFullAccessToProject',
            ForceHttps: 'Options_ForceHttps',
            AttachmentsSpace: 'Options_AttachmentsSpace',
            HasPaymentProblem: 'Options_HasPaymentProblem',
            UseActualCompletionDateForDependencies: 'Options_UseActualCompletionDateForDependencies',
            IsSuspended: 'Options_IsSuspended',
            ProjectMessagesAttachmentsVisibleForLA: 'Options_ProjectMessagesAttachmentsVisibleForLA',
            BreakevenRate: 'Options_BreakevenRate',
            WorkWeekStartsOn: 'Options_WorkWeekStartsOn',
            WorkOverWeekendRate: 'Options_WorkOverWeekendRate',
            WorkOverWeekendThreshold: 'Options_WorkOverWeekendThreshold',
            MaxSickHoursPerYear: 'Options_MaxSickHoursPerYear',
            ShowWalkMe: 'Options_ShowWalkMe',
            CalculateHealthUseBothParams: 'Options_CalculateHealthUseBothParams',
            HideUserLoginField: 'Options_HideUserLoginField',
            IsEnableApproveWorkflowOptionVisible: 'Options_IsEnableApproveWorkflowOptionVisible',
            ApprovalWorkflow: 'Options_ApprovalWorkflow',
            IsSSOEnabled: 'Options_IsSSOEnabled',
            SSORoleId: 'Options_SSORoleId',
            IsNewSessionSigninRequired: 'Options_IsNewSessionSigninRequired',
            SSODomainForEmails: 'Options_SSODomainForEmails',
            ForceSSO: 'Options_ForceSSO',
            DefaultCurrencyId: 'Options_DefaultCurrencyId',
            EnableWebPushNotifications: 'Options_EnableWebPushNotifications',
        },
        MailFromNameMaxLength: 50,
        MailFromAddressMaxLength: 50,
        SmtpServerMaxLength: 50,
        SmtpPortMaxValue: 65535,
        SmtpPortMinValue: 0,
        SmtpUserNameMaxLength: 50,
        SmtpPasswordMaxLength: 50,
        Pop3ServerMaxLength: 50,
        Pop3PortMaxValue: 65535,
        Pop3PortMinValue: 0,
        Pop3UserNameMaxLength: 50,
        Pop3PasswordMaxLength: 50,
        NumberOfHoursPerDayMaxValue: 24,
        NumberOfHoursPerDayMinValue: 1,
        SPIThresholdMaxValue: 100,
        SPIThresholdMinValue: 0,
        CPIThresholdMaxValue: 100,
        CPIThresholdMinValue: 0,
        PasswordLengthMaxValue: 50,
        PasswordLengthMinValue: 1,
        PasswordNumbersCountMaxValue: 50,
        PasswordNumbersCountMinValue: 0,
        PasswordSpecSymbolsCountMaxValue: 50,
        PasswordSpecSymbolsCountMinValue: 0,
        InvalidPasswordAttemptsMaxValue: 100,
        InvalidPasswordAttemptsMinValue: 1,
        UnblockAutomaticallyInMaxValue: 999,
        UnblockAutomaticallyInMinValue: 1,
        MaxUserInactivityMaxValue: 999,
        MaxUserInactivityMinValue: 1,
        PasswordExpirationMaxValue: 90,
        PasswordExpirationMinValue: 1,
        BreakevenRateMaxValue: 100,
        BreakevenRateMinValue: 0,
        WorkWeekStartsOnMaxValue: 6,
        WorkWeekStartsOnMinValue: 0,
        WorkOverWeekendRateMaxValue: 999,
        WorkOverWeekendThresholdMaxValue: 999,
        MaxSickHoursPerYearMaxValue: 999,
        MaxSickHoursPerYearMinValue: 0,
    },
    OvertimeThreshold: {
        fields: {
            OvertimeThresholdID: 'OvertimeThreshold_OvertimeThresholdID',
            Threshold: 'OvertimeThreshold_Threshold',
            RateMultiplier: 'OvertimeThreshold_RateMultiplier',
        },
        ThresholdMaxValue: 999,
        ThresholdMinValue: 0,
        RateMultiplierMaxValue: 999,
    },
    PasswordIgnoreWords: {
        fields: {
            PasswordIgnoreWordsID: 'PasswordIgnoreWords_PasswordIgnoreWordsID',
            Word: 'PasswordIgnoreWords_Word',
        },
    },
    Payment: {
        fields: {
            PaymentID: 'Payment_PaymentID',
            PaymentDate: 'Payment_PaymentDate',
            Amount: 'Payment_Amount',
            Description: 'Payment_Description',
            Billable: 'Payment_Billable',
            Planned: 'Payment_Planned',
            Billed: 'Payment_Billed',
        },
        AmountMaxValue: 9999999999999,
        AmountMinValue: 0,
        DescriptionMaxLength: 4000,
    },
    Portfolio: {
        fields: {
            PortfolioID: 'Portfolio_PortfolioID',
            CreationDate: 'Portfolio_CreationDate',
            Name: 'Portfolio_Name',
            Description: 'Portfolio_Description',
            Managers: 'Portfolio_Managers',
            ManagersComma: 'Portfolio_ManagersComma',
            ManagersSeparateLines: 'Portfolio_ManagersSeparateLines',
            Members: 'Portfolio_Members',
            HasProjects: 'Portfolio_HasProjects',
        },
        NameMaxLength: 100,
        DescriptionMaxLength: 400000,
    },
    PortfolioMember: {
        fields: {
            PortfolioMemberID: 'PortfolioMember_PortfolioMemberID',
            CanEdit: 'PortfolioMember_CanEdit',
            CanView: 'PortfolioMember_CanView',
            IsPortfolioManager: 'PortfolioMember_IsPortfolioManager',
        },
    },
    PortfolioMembersManagers: {
        fields: {
            PortfolioMemberID: 'PortfolioMembersManagers_PortfolioMemberID',
            UserName: 'PortfolioMembersManagers_UserName',
        },
    },
    Preset: {
        fields: {
            PresetID: 'Preset_PresetID',
            Name: 'Preset_Name',
            BasePresetID: 'Preset_BasePresetID',
            FilterXML: 'Preset_FilterXML',
            CustomizationXML: 'Preset_CustomizationXML',
            SortEpxressionXML: 'Preset_SortEpxressionXML',
            ViewType: 'Preset_ViewType',
            IsShared: 'Preset_IsShared',
            IsDefault: 'Preset_IsDefault',
            LastModificationDate: 'Preset_LastModificationDate',
            GanttZoomLevel: 'Preset_GanttZoomLevel',
            KanbanColumns: 'Preset_KanbanColumns',
        },
        NameMaxLength: 400,
        FilterXMLMaxLength: 1000000,
        CustomizationXMLMaxLength: 1000000,
        SortEpxressionXMLMaxLength: 1000000,
    },
    PresetSettings: {
        fields: {
            PresetSettingsID: 'PresetSettings_PresetSettingsID',
            IsVisible: 'PresetSettings_IsVisible',
        },
    },
    Priority: {
        fields: {
            PriorityID: 'Priority_PriorityID',
            Name: 'Priority_Name',
            PriorityOrder: 'Priority_PriorityOrder',
            InternalPriorityID: 'Priority_InternalPriorityID',
        },
        NameMaxLength: 255,
        PriorityOrderMaxValue: 100,
        PriorityOrderMinValue: 0,
    },
    Project: {
        fields: {
            ProjectID: 'Project_ProjectID',
            Name: 'Project_Name',
            Description: 'Project_Description',
            Progress: 'Project_Progress',
            CreationDate: 'Project_CreationDate',
            StartDate: 'Project_StartDate',
            EndDate: 'Project_EndDate',
            ActCompletionDate: 'Project_ActCompletionDate',
            EstimatedHours: 'Project_EstimatedHours',
            BillingType: 'Project_BillingType',
            BillingAmount: 'Project_BillingAmount',
            Budget: 'Project_Budget',
            LastModificationDate: 'Project_LastModificationDate',
            Billed: 'Project_Billed',
            Duration: 'Project_Duration',
            DurationHours: 'Project_DurationHours',
            HasDescription: 'Project_HasDescription',
            StartDateLag: 'Project_StartDateLag',
            EndDateLag: 'Project_EndDateLag',
            BaselineDate: 'Project_BaselineDate',
            BaselineStartDate: 'Project_BaselineStartDate',
            BaselineEndDate: 'Project_BaselineEndDate',
            BaselineStartLag: 'Project_BaselineStartLag',
            BaselineEndLag: 'Project_BaselineEndLag',
            StartDateVariance: 'Project_StartDateVariance',
            EndDateVariance: 'Project_EndDateVariance',
            BaselineBudgetedCost:'Project_BaselineBudgetedCost',
            BaselineBudget:'Project_BaselineBudget',
            BaselineEstimatedHours:'Project_BaselineEstimatedHours',

        },
        NameMaxLength: 255,
        DescriptionMaxLength: 1000000,
        ProgressMaxValue: 100,
        ProgressMinValue: 0,
        EstimatedHoursMaxValue: 9999999,
        EstimatedHoursMinValue: 0,
        BillingAmountMaxValue: 99999999999999,
        BillingAmountMinValue: 0,
        BudgetMaxValue: 999999999999999,
        BudgetMinValue: -999999999999999,
    },
    ProjectAggregatedValues: {
        fields: {
            ProjectAggregatedValues_Project_ProjectID: 'ProjectAggregatedValues_ProjectAggregatedValues_Project_ProjectID',
            ActualHours: 'ProjectAggregatedValues_ActualHours',
            BillableHours: 'ProjectAggregatedValues_BillableHours',
            NonBillableHours: 'ProjectAggregatedValues_NonBillableHours',
            Budget: 'ProjectAggregatedValues_Budget',
            EstimatedHours: 'ProjectAggregatedValues_EstimatedHours',
            ChildsBudget: 'ProjectAggregatedValues_ChildsBudget',
            ChildsEstimatedHours: 'ProjectAggregatedValues_ChildsEstimatedHours',
            ChildsHoursLeft: 'ProjectAggregatedValues_ChildsHoursLeft',
            InternalCost: 'ProjectAggregatedValues_InternalCost',
        },
        BudgetMaxValue: 999999999999999,
        BudgetMinValue: -999999999999999,
    },
    ProjectAggregatedValuesForProject: {
        fields: {
            ProjectAggregatedValues_ProjectID: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_ProjectID',
            ProjectAggregatedValues_ActualHours: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_ActualHours',
            ProjectAggregatedValues_Budget: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_Budget',
            ProjectAggregatedValues_EstimatedHours: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_EstimatedHours',
            ProjectAggregatedValues_ChildsBudget: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_ChildsBudget',
            ProjectAggregatedValues_ChildsEstimatedHours: 'ProjectAggregatedValuesForProject_ProjectAggregatedValues_ChildsEstimatedHours',
        },
    },
    ProjectAutoAssign: {
        fields: {
            ProjectAutoAssignID: 'ProjectAutoAssign_ProjectAutoAssignID',
        },
    },
    ProjectCurrency: {
        fields: {
            CurrencyID: 'ProjectCurrency_CurrencyID',
            CurrencyName: 'ProjectCurrency_CurrencyName',
            CurrencySymbol: 'ProjectCurrency_CurrencySymbol',
            CurrencyText: 'ProjectCurrency_CurrencyText',
            SortLevel: 'ProjectCurrency_SortLevel',
        },
    },
    ProjectEVA: {
        fields: {
            Health: 'ProjectEVA_Health',
            CPI: 'ProjectEVA_CPI',
            SPI: 'ProjectEVA_SPI',
        },
    },
    ProjectExpand: {
        fields: {
            ProjectID: 'ProjectExpand_ProjectID',
            UserID: 'ProjectExpand_UserID',
        },
    },
    ProjectFinancials: {
        fields: {
            Project_Cost: 'ProjectFinancials_Project_Cost',
            Project_InternalCost: 'ProjectFinancials_Project_InternalCost',
            Project_ProjectProfit: 'ProjectFinancials_Project_ProjectProfit',
            Project_ProjectProfitHealth: 'ProjectFinancials_Project_ProjectProfitHealth',
            Project_ProjectProfitability: 'ProjectFinancials_Project_ProjectProfitability',
            Project_ProjectCostVariance: 'ProjectFinancials_Project_ProjectCostVariance',
            Project_BudgetedCost: 'ProjectFinancials_Project_BudgetedCost',
            Project_PlannedExpenses: 'ProjectFinancials_Project_PlannedExpenses',
            Project_TotalPayments: 'ProjectFinancials_Project_TotalPayments',
            Project_ProjectExpectedRevenue: 'ProjectFinancials_Project_ProjectExpectedRevenue',
            Project_PercentageOfProjectBilled: 'ProjectFinancials_Project_PercentageOfProjectBilled',
            Project_WorkInProgress: 'ProjectFinancials_Project_WorkInProgress',
            Project_TotalBilled: 'ProjectFinancials_Project_TotalBilled',
            Project_ProjectTimeUsage: 'ProjectFinancials_Project_ProjectTimeUsage',
            Project_BillingUtilization: 'ProjectFinancials_Project_BillingUtilization',
            Project_InternalEstimatedCost: 'ProjectFinancials_Project_InternalEstimatedCost',
            Project_EstimatedBudgetProfitability: 'ProjectFinancials_Project_EstimatedBudgetProfitability',
            Project_ActualBudgetProfitability: 'ProjectFinancials_Project_ActualBudgetProfitability',
        },
    },
    ProjectMember: {
        fields: {
            ProjectMemberID: 'ProjectMember_ProjectMemberID',
        },
    },
    ProjectMessageBoardData: {
        fields: {
            AttachmentsLastModificationDate: 'ProjectMessageBoardData_AttachmentsLastModificationDate',
            MessagesLastModificationDate: 'ProjectMessageBoardData_MessagesLastModificationDate',
            ApproveLastModificationDate: 'ProjectMessageBoardData_ApproveLastModificationDate',
            MessagesCount: 'ProjectMessageBoardData_MessagesCount',
            PostsCount: 'ProjectMessageBoardData_PostsCount',
            AttachmentsCount: 'ProjectMessageBoardData_AttachmentsCount',
        },
    },
    ProjectName: {
        fields: {
            ProjectID: 'ProjectName_ProjectID',
            Name: 'ProjectName_Name',
        },
        NameMaxLength: 100,
    },
    ProjectNotification: {
        fields: {
            ProjectNotificationID: 'ProjectNotification_ProjectNotificationID',
            Enabled: 'ProjectNotification_Enabled',
        },
    },
    ProjectNotificationUser: {
        fields: {
            ProjectNotificationUserID: 'ProjectNotificationUser_ProjectNotificationUserID',
        },
    },
    ProjectNotificationUserOptions: {
        fields: {
            ProjectNotificationsUserOptionsID: 'ProjectNotificationUserOptions_ProjectNotificationsUserOptionsID',
            NotificationType: 'ProjectNotificationUserOptions_NotificationType',
            EventTaskAdd: 'ProjectNotificationUserOptions_EventTaskAdd',
            EventTaskEdit: 'ProjectNotificationUserOptions_EventTaskEdit',
            EventTaskAssign: 'ProjectNotificationUserOptions_EventTaskAssign',
            EventTaskCanStart: 'ProjectNotificationUserOptions_EventTaskCanStart',
            EventTaskComplete: 'ProjectNotificationUserOptions_EventTaskComplete',
            EventTaskDelete: 'ProjectNotificationUserOptions_EventTaskDelete',
            EventTaskLate: 'ProjectNotificationUserOptions_EventTaskLate',
            EventIssueAdd: 'ProjectNotificationUserOptions_EventIssueAdd',
            EventIssueEdit: 'ProjectNotificationUserOptions_EventIssueEdit',
            EventIssueAssign: 'ProjectNotificationUserOptions_EventIssueAssign',
            EventIssueCanStart: 'ProjectNotificationUserOptions_EventIssueCanStart',
            EventIssueComplete: 'ProjectNotificationUserOptions_EventIssueComplete',
            EventIssueDelete: 'ProjectNotificationUserOptions_EventIssueDelete',
            EventIssueLate: 'ProjectNotificationUserOptions_EventIssueLate',
            EventRequestAdd: 'ProjectNotificationUserOptions_EventRequestAdd',
            EventRequestEdit: 'ProjectNotificationUserOptions_EventRequestEdit',
            EventRequestAssign: 'ProjectNotificationUserOptions_EventRequestAssign',
            EventRequestCanStart: 'ProjectNotificationUserOptions_EventRequestCanStart',
            EventRequestComplete: 'ProjectNotificationUserOptions_EventRequestComplete',
            EventRequestDelete: 'ProjectNotificationUserOptions_EventRequestDelete',
            EventRequestLate: 'ProjectNotificationUserOptions_EventRequestLate',
            EventMessageAdd: 'ProjectNotificationUserOptions_EventMessageAdd',
        },
    },
    PublicHoliday: {
        fields: {
            PublicHolidayID: 'PublicHoliday_PublicHolidayID',
            Name: 'PublicHoliday_Name',
            Date: 'PublicHoliday_Date',
        },
        NameMaxLength: 255,
    },
    PushNotificationInstallation: {
        fields: {
            ID: 'PushNotificationInstallation_ID',
            InstallationId: 'PushNotificationInstallation_InstallationId',
            AccountID: 'PushNotificationInstallation_AccountID',
            UserID: 'PushNotificationInstallation_UserID',
            Platform: 'PushNotificationInstallation_Platform',
            PnsIdentifier: 'PushNotificationInstallation_PnsIdentifier',
            WebEndPoint: 'PushNotificationInstallation_WebEndPoint',
            WebAuthKey: 'PushNotificationInstallation_WebAuthKey',
            WebP256dhKey: 'PushNotificationInstallation_WebP256dhKey',
        },
    },
    Report: {
        fields: {
            ReportID: 'Report_ReportID',
            Name: 'Report_Name',
            ColumnsInformation: 'Report_ColumnsInformation',
            FontName: 'Report_FontName',
            FontSize: 'Report_FontSize',
            IsFontBold: 'Report_IsFontBold',
            IsFontItalic: 'Report_IsFontItalic',
            IsFontUnderline: 'Report_IsFontUnderline',
            IsVerticalChartLabels: 'Report_IsVerticalChartLabels',
            PageOrientation: 'Report_PageOrientation',
            ReportType: 'Report_ReportType',
            CountWidgets: 'Report_CountWidgets',
            ShowOnDashboard: 'Report_ShowOnDashboard',
        },
        NameMaxLength: 200,
        ColumnsInformationMaxLength: 1000000,
    },
    ReportDataSource: {
        fields: {
            ReportDataSourceID: 'ReportDataSource_ReportDataSourceID',
            DisplayName: 'ReportDataSource_DisplayName',
            ViewName: 'ReportDataSource_ViewName',
            Priority: 'ReportDataSource_Priority',
        },
    },
    Role: {
        fields: {
            RoleID: 'Role_RoleID',
            Name: 'Role_Name',
            Description: 'Role_Description',
            HourlyRate: 'Role_HourlyRate',
            CanManage: 'Role_CanManage',
            CanAccessReports: 'Role_CanAccessReports',
            CanAccessReportGenerator: 'Role_CanAccessReportGenerator',
            CanCreateProjects: 'Role_CanCreateProjects',
            CanAccessProjects: 'Role_CanAccessProjects',
            CanAddPortfolios: 'Role_CanAddPortfolios',
            CanManageAllPortfolios: 'Role_CanManageAllPortfolios',
            CanAccessBillingInformation: 'Role_CanAccessBillingInformation',
            CanManageOwnVacations: 'Role_CanManageOwnVacations',
            CanManageOtherPeopleVacations: 'Role_CanManageOtherPeopleVacations',
            CanManageCustomers: 'Role_CanManageCustomers',
            CanAddForms: 'Role_CanAddForms',
            CanManageForms: 'Role_CanManageForms',
            CanInviteUsers: 'Role_CanInviteUsers',
            InternalRoleID: 'Role_InternalRoleID',
            CanPurchase: 'Role_CanPurchase',
        },
        NameMaxLength: 255,
        DescriptionMaxLength: 2000,
        HourlyRateMaxValue: 99999999,
        HourlyRateMinValue: 0,
    },
    ScopeRole: {
        fields: {
            RoleID: 'ScopeRole_RoleID',
            Name: 'ScopeRole_Name',
            CanManageSystemSettings: 'ScopeRole_CanManageSystemSettings',
            CanAccessReports: 'ScopeRole_CanAccessReports',
            CanAccessReportGenerator: 'ScopeRole_CanAccessReportGenerator',
            CanCreateProjects: 'ScopeRole_CanCreateProjects',
            CanAccessProjects: 'ScopeRole_CanAccessProjects',
            CanAccessBillingInformation: 'ScopeRole_CanAccessBillingInformation',
            CanManageCustomers: 'ScopeRole_CanManageCustomers',
            CanAddForms: 'ScopeRole_CanAddForms',
            CanManageForms: 'ScopeRole_CanManageForms',
            CanManageAllPortfolios: 'ScopeRole_CanManageAllPortfolios',
            CanAddPortfolios: 'ScopeRole_CanAddPortfolios',
            CanManageOwnVacations: 'ScopeRole_CanManageOwnVacations',
            CanManageOtherPeopleVacations: 'ScopeRole_CanManageOtherPeopleVacations',
            CanInviteUsers: 'ScopeRole_CanInviteUsers',
            InternalRoleID: 'ScopeRole_InternalRoleID',
            CanPurchase: 'ScopeRole_CanPurchase',
        },
    },
    ScopeUser: {
        fields: {
            UserID: 'ScopeUser_UserID',
            Name: 'ScopeUser_Name',
            Password: 'ScopeUser_Password',
            ShowCompletedTasks: 'ScopeUser_ShowCompletedTasks',
            ShowCompletedProjects: 'ScopeUser_ShowCompletedProjects',
            ShowCompletedPortfolios: 'ScopeUser_ShowCompletedPortfolios',
            ShowAvatars: 'ScopeUser_ShowAvatars',
            Avatar: 'ScopeUser_Avatar',
            LastActivityDate: 'ScopeUser_LastActivityDate',
            DefaultPage: 'ScopeUser_DefaultPage',
            EMail: 'ScopeUser_EMail',
            Login: 'ScopeUser_Login',
            PresetID: 'ScopeUser_PresetID',
            Enabled: 'ScopeUser_Enabled',
            CanLogin: 'ScopeUser_CanLogin',
            TimeZoneOffset: 'ScopeUser_TimeZoneOffset',
            IsCurrentProjectManager: 'ScopeUser_IsCurrentProjectManager',
            IsDistributeHours: 'ScopeUser_IsDistributeHours',
            IsExpandAssigneeWindow: 'ScopeUser_IsExpandAssigneeWindow',
            AuthVersion: 'ScopeUser_AuthVersion',
            IsOnboardingPassed: 'ScopeUser_IsOnboardingPassed',
        },
        NameMaxLength: 50,
        PasswordMaxLength: 50,
    },
    SecurityLog: {
        fields: {
            EntryID: 'SecurityLog_EntryID',
            EntryDate: 'SecurityLog_EntryDate',
            MessageType: 'SecurityLog_MessageType',
            ActorUserName: 'SecurityLog_ActorUserName',
            Payload: 'SecurityLog_Payload',
        },
    },
    SendEmail: {
        fields: {
            AccountID: 'SendEmail_AccountID',
            ID: 'SendEmail_ID',
            UserID: 'SendEmail_UserID',
            Email: 'SendEmail_Email',
            Subject: 'SendEmail_Subject',
            Body: 'SendEmail_Body',
            ReplyToken: 'SendEmail_ReplyToken',
            SendStatus: 'SendEmail_SendStatus',
            AddedDate: 'SendEmail_AddedDate',
            SendDate: 'SendEmail_SendDate',
            RetryCount: 'SendEmail_RetryCount',
            SendError: 'SendEmail_SendError',
            IsSystem: 'SendEmail_IsSystem',
        },
    },
    Skill: {
        fields: {
            SkillID: 'Skill_SkillID',
            Name: 'Skill_Name',
        },
        NameMaxLength: 255,
    },
    Status: {
        fields: {
            StatusID: 'Status_StatusID',
            Name: 'Status_Name',
            MetaType: 'Status_MetaType',
            Order: 'Status_Order',
            IsDraft: 'Status_IsDraft',
            IsTemplate: 'Status_IsTemplate',
            TreatAsOpen: 'Status_TreatAsOpen',
            TreatAsHold: 'Status_TreatAsHold',
            TreatAsCompleted: 'Status_TreatAsCompleted',
        },
        NameMaxLength: 255,
    },
    StatusReport: {
        fields: {
            StatusReportID: 'StatusReport_StatusReportID',
            CreationDate: 'StatusReport_CreationDate',
            ProjectEndDate: 'StatusReport_ProjectEndDate',
            LastModificationDate: 'StatusReport_LastModificationDate',
            Progress: 'StatusReport_Progress',
            Plans: 'StatusReport_Plans',
            Problems: 'StatusReport_Problems',
            ScopeValue: 'StatusReport_ScopeValue',
            ScopeDescription: 'StatusReport_ScopeDescription',
            ScheduleValue: 'StatusReport_ScheduleValue',
            ScheduleDescription: 'StatusReport_ScheduleDescription',
            CostValue: 'StatusReport_CostValue',
            CostDescription: 'StatusReport_CostDescription',
            ResourcesValue: 'StatusReport_ResourcesValue',
            ResourcesDescription: 'StatusReport_ResourcesDescription',
        },
        ProgressMaxLength: 1000,
        PlansMaxLength: 1000,
        ProblemsMaxLength: 1000,
        ScopeDescriptionMaxLength: 250,
        ScheduleDescriptionMaxLength: 250,
        CostDescriptionMaxLength: 250,
        ResourcesDescriptionMaxLength: 250,
    },
    Task: {
        fields: {
            TaskID: 'Task_TaskID',
            Name: 'Task_Name',
            Description: 'Task_Description',
            ParentID: 'Task_ParentID',
            Progress: 'Task_Progress',
            ActualCompletionDate: 'Task_ActualCompletionDate',
            CreationDate: 'Task_CreationDate',
            StartDate: 'Task_StartDate',
            EndDate: 'Task_EndDate',
            Duration: 'Task_Duration',
            DurationHours: 'Task_DurationHours',
            StartDateLag: 'Task_StartDateLag',
            EndDateLag: 'Task_EndDateLag',
            EstimatedHours: 'Task_EstimatedHours',
            HoursLeft: 'Task_HoursLeft',
            BillingType: 'Task_BillingType',
            BillingAmount: 'Task_BillingAmount',
            Cost: 'Task_Cost',
            IsMilestone: 'Task_IsMilestone',
            HasChild: 'Task_HasChild',
            Budget: 'Task_Budget',
            LastModificationDate: 'Task_LastModificationDate',
            WBSNumber: 'Task_WBSNumber',
            Approved: 'Task_Approved',
            Billed: 'Task_Billed',
            HasDescription: 'Task_HasDescription',
            StartDateForGantt: 'Task_StartDateForGantt',
            EndDateForGantt: 'Task_EndDateForGantt',
            LagForGantt: 'Task_LagForGantt',
            BaselineStartDate: 'Task_BaselineStartDate',
            BaselineEndDate: 'Task_BaselineEndDate',
            BaselineStartLag: 'Task_BaselineStartLag',
            BaselineEndLag: 'Task_BaselineEndLag',
            StartDateVariance: 'Task_StartDateVariance',
            EndDateVariance: 'Task_EndDateVariance',
            SourceRepeatTaskId: 'Task_SourceRepeatTaskId',
            IsRepeatSource: 'Task_IsRepeatSource',
            RepeatWrapperForTaskId: 'Task_RepeatWrapperForTaskId',
            BaselineBudget: 'Task_BaselineBudget',
            BaselineOwnEstimatedHours:'Task_BaselineOwnEstimatedHours',
        },
        NameMaxLength: 250,
        DescriptionMaxLength: 1000000,
        ProgressMaxValue: 100,
        ProgressMinValue: 0,
        DurationMaxValue: 9999,
        DurationMaxLength: 5,
        DurationMinValue: 0,
        EstimatedHoursMaxValue: 99999,
        EstimatedHoursMinValue: 0,
        HoursLeftMaxValue: 99999,
        HoursLeftMinValue: 0,
        BillingAmountMaxValue: 99999999999999,
        BillingAmountNegativeMinValue: -99999999999999,
        BillingAmountMinValue: 0,
        BudgetMaxValue: 999999999999999,
        BudgetMinValue: -999999999999999,
    },
    TaskAggregatedValues: {
        fields: {
            TaskAggregatedValues_Task_TaskID: 'TaskAggregatedValues_TaskAggregatedValues_Task_TaskID',
            ActualHours: 'TaskAggregatedValues_ActualHours',
            BillableHours: 'TaskAggregatedValues_BillableHours',
            NonBillableHours: 'TaskAggregatedValues_NonBillableHours',
            Budget: 'TaskAggregatedValues_Budget',
            EstimatedHours: 'TaskAggregatedValues_EstimatedHours',
            ChildsActualHours: 'TaskAggregatedValues_ChildsActualHours',
            ChildsBudget: 'TaskAggregatedValues_ChildsBudget',
            ChildsEstimatedHours: 'TaskAggregatedValues_ChildsEstimatedHours',
            ChildsHoursLeft: 'TaskAggregatedValues_ChildsHoursLeft',
            OwnEstimatedHours: 'TaskAggregatedValues_OwnEstimatedHours',
            Cost: 'TaskAggregatedValues_Cost',
            InternalCost: 'TaskAggregatedValues_InternalCost',
        },
        BudgetMaxValue: 999999999999999,
        BudgetMinValue: -999999999999999,
    },
    TaskAggregatedValuesForProject: {
        fields: {
            TaskAggregatedValues_TaskID: 'TaskAggregatedValuesForProject_TaskAggregatedValues_TaskID',
            TaskAggregatedValues_ActualHours: 'TaskAggregatedValuesForProject_TaskAggregatedValues_ActualHours',
            TaskAggregatedValues_Budget: 'TaskAggregatedValuesForProject_TaskAggregatedValues_Budget',
            TaskAggregatedValues_EstimatedHours: 'TaskAggregatedValuesForProject_TaskAggregatedValues_EstimatedHours',
            TaskAggregatedValues_ChildsActualHours: 'TaskAggregatedValuesForProject_TaskAggregatedValues_ChildsActualHours',
            TaskAggregatedValues_ChildsBudget: 'TaskAggregatedValuesForProject_TaskAggregatedValues_ChildsBudget',
            TaskAggregatedValues_ChildsEstimatedHours: 'TaskAggregatedValuesForProject_TaskAggregatedValues_ChildsEstimatedHours',
            TaskAggregatedValues_OwnEstimatedHours: 'TaskAggregatedValuesForProject_TaskAggregatedValues_OwnEstimatedHours',
        },
    },
    TaskAggregatedValuesForProject2: {
        fields: {
            TaskAggregatedValues_TaskID: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_TaskID',
            TaskAggregatedValues_ActualHours: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_ActualHours',
            TaskAggregatedValues_Budget: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_Budget',
            TaskAggregatedValues_EstimatedHours: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_EstimatedHours',
            TaskAggregatedValues_ChildsActualHours: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_ChildsActualHours',
            TaskAggregatedValues_ChildsBudget: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_ChildsBudget',
            TaskAggregatedValues_ChildsEstimatedHours: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_ChildsEstimatedHours',
            TaskAggregatedValues_OwnEstimatedHours: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_OwnEstimatedHours',
            TaskAggregatedValues_HasChild: 'TaskAggregatedValuesForProject2_TaskAggregatedValues_HasChild',
        },
    },
    TaskAggregatedValuesForTask: {
        fields: {
            TaskAggregatedValues_TaskID: 'TaskAggregatedValuesForTask_TaskAggregatedValues_TaskID',
            TaskAggregatedValues_ActualHours: 'TaskAggregatedValuesForTask_TaskAggregatedValues_ActualHours',
            TaskAggregatedValues_Budget: 'TaskAggregatedValuesForTask_TaskAggregatedValues_Budget',
            TaskAggregatedValues_EstimatedHours: 'TaskAggregatedValuesForTask_TaskAggregatedValues_EstimatedHours',
            TaskAggregatedValues_ChildsActualHours: 'TaskAggregatedValuesForTask_TaskAggregatedValues_ChildsActualHours',
            TaskAggregatedValues_ChildsBudget: 'TaskAggregatedValuesForTask_TaskAggregatedValues_ChildsBudget',
            TaskAggregatedValues_ChildsEstimatedHours: 'TaskAggregatedValuesForTask_TaskAggregatedValues_ChildsEstimatedHours',
            TaskAggregatedValues_OwnEstimatedHours: 'TaskAggregatedValuesForTask_TaskAggregatedValues_OwnEstimatedHours',
        },
    },
    TaskAggregatedValuesSingle: {
        fields: {
            TaskAggregatedValues_ActualHours: 'TaskAggregatedValuesSingle_TaskAggregatedValues_ActualHours',
            Budget: 'TaskAggregatedValuesSingle_Budget',
            TaskAggregatedValues_EstimatedHours: 'TaskAggregatedValuesSingle_TaskAggregatedValues_EstimatedHours',
            TaskAggregatedValues_ChildsActualHours: 'TaskAggregatedValuesSingle_TaskAggregatedValues_ChildsActualHours',
            ChildsBudget: 'TaskAggregatedValuesSingle_ChildsBudget',
            TaskAggregatedValues_ChildsEstimatedHours: 'TaskAggregatedValuesSingle_TaskAggregatedValues_ChildsEstimatedHours',
            TaskAggregatedValues_InternalCost: 'TaskAggregatedValuesSingle_TaskAggregatedValues_InternalCost',
        },
    },
    TaskAssignee: {
        fields: {
            TaskAssigneeID: 'TaskAssignee_TaskAssigneeID',
            WorkIsDone: 'TaskAssignee_WorkIsDone',
            PersonalHoursLeft: 'TaskAssignee_PersonalHoursLeft',
            PersonalEstimatedHours: 'TaskAssignee_PersonalEstimatedHours',
            WorkIsDoneSetDate: 'TaskAssignee_WorkIsDoneSetDate',
        },
    },
    TaskBillable: {
        fields: {
            TaskID: 'TaskBillable_TaskID',
            IsBillable: 'TaskBillable_IsBillable',
        },
    },
    TaskCost: {
        fields: {
            TaskID: 'TaskCost_TaskID',
            Task_Cost: 'TaskCost_Task_Cost',
        },
    },
    TaskCriticalPath: {
        fields: {
            TaskCriticalPath_Task_TaskID: 'TaskCriticalPath_TaskCriticalPath_Task_TaskID',
            ProjectID: 'TaskCriticalPath_ProjectID',
            IsCriticalPath: 'TaskCriticalPath_IsCriticalPath',
        },
    },
    TaskDependency: {
        fields: {
            TaskDependencyID: 'TaskDependency_TaskDependencyID',
            Type: 'TaskDependency_Type',
            Delay: 'TaskDependency_Delay',
        },
        DelayMaxValue: 1000,
        DelayMinValue: -1000,
    },
    TaskEVA: {
        fields: {
            Health: 'TaskEVA_Health',
            CPI: 'TaskEVA_CPI',
            SPI: 'TaskEVA_SPI',
        },
    },
    TaskExpand: {
        fields: {
            TaskID: 'TaskExpand_TaskID',
            UserID: 'TaskExpand_UserID',
        },
    },
    TaskHierarchy: {
        fields: {
            AncestorID: 'TaskHierarchy_AncestorID',
            DescendantID: 'TaskHierarchy_DescendantID',
        },
    },
    TaskHoursLeft: {
        fields: {
            TaskID: 'TaskHoursLeft_TaskID',
            HoursLeft: 'TaskHoursLeft_HoursLeft',
        },
    },
    TaskMessageBoardData: {
        fields: {
            AttachmentsLastModificationDate: 'TaskMessageBoardData_AttachmentsLastModificationDate',
            MessagesLastModificationDate: 'TaskMessageBoardData_MessagesLastModificationDate',
            ApproveLastModificationDate: 'TaskMessageBoardData_ApproveLastModificationDate',
            MessagesCount: 'TaskMessageBoardData_MessagesCount',
            PostsCount: 'TaskMessageBoardData_PostsCount',
            AttachmentsCount: 'TaskMessageBoardData_AttachmentsCount',
        },
    },
    TaskPermissions: {
        fields: {
            TaskID: 'TaskPermissions_TaskID',
            UserID: 'TaskPermissions_UserID',
            CanEdit: 'TaskPermissions_CanEdit',
            CanDelete: 'TaskPermissions_CanDelete',
        },
    },
    TaskSettings: {
        fields: {
            RepeatSettings: 'TaskSettings_RepeatSettings',
            RepeatTaskLastDate: 'TaskSettings_RepeatTaskLastDate',
        },
    },
    TaskStatusStatisticsReportEntity: {
        fields: {
            StatusName: 'TaskStatusStatisticsReportEntity_StatusName',
            DaysSpent: 'TaskStatusStatisticsReportEntity_DaysSpent',
        },
    },
    TaskTimer: {
        fields: {
            Id: 'TaskTimer_Id',
            StartTime: 'TaskTimer_StartTime',
            ElapsedSeconds: 'TaskTimer_ElapsedSeconds',
        },
    },
    TaskType: {
        fields: {
            TaskTypeID: 'TaskType_TaskTypeID',
            Name: 'TaskType_Name',
        },
    },
    Team: {
        fields: {
            TeamID: 'Team_TeamID',
            Name: 'Team_Name',
        },
        NameMaxLength: 255,
    },
    TempImage: {
        fields: {
            TempImageID: 'TempImage_TempImageID',
            ImageKey: 'TempImage_ImageKey',
            ImageBytes: 'TempImage_ImageBytes',
        },
    },
    Test: {
        fields: {
            TestID: 'Test_TestID',
            Name: 'Test_Name',
        },
    },
    Test2: {
        fields: {
            TestID: 'Test2_TestID',
            Name: 'Test2_Name',
            Description: 'Test2_Description',
            TestField1: 'Test2_TestField1',
            TestField2: 'Test2_TestField2',
            TestField3: 'Test2_TestField3',
            Date: 'Test2_Date',
            Amount: 'Test2_Amount',
        },
    },
    TestAccount: {
        fields: {
            TestID: 'TestAccount_TestID',
            AccountID: 'TestAccount_AccountID',
            Name: 'TestAccount_Name',
        },
    },
    TestChild: {
        fields: {
            TestChildID: 'TestChild_TestChildID',
            Name: 'TestChild_Name',
            Date: 'TestChild_Date',
            Amount: 'TestChild_Amount',
        },
    },
    TestChildNonMandatoryRef: {
        fields: {
            TestChildID: 'TestChildNonMandatoryRef_TestChildID',
            Name: 'TestChildNonMandatoryRef_Name',
            Date: 'TestChildNonMandatoryRef_Date',
            Amount: 'TestChildNonMandatoryRef_Amount',
        },
    },
    TestExpr: {
        fields: {
            TestID: 'TestExpr_TestID',
            Expr1: 'TestExpr_Expr1',
        },
    },
    TestWithAdditionWhere: {
        fields: {
            ID: 'TestWithAdditionWhere_ID',
        },
    },
    TestWithROField: {
        fields: {
            TROFID: 'TestWithROField_TROFID',
            ReadOnlyField: 'TestWithROField_ReadOnlyField',
        },
    },
    Threshold: {
        fields: {
            ThresholdID: 'Threshold_ThresholdID',
            Name: 'Threshold_Name',
            Value: 'Threshold_Value',
            Color: 'Threshold_Color',
        },
        NameMaxLength: 255,
        ValueMaxValue: 99.99,
        ValueMinValue: 0.01,
        ColorMaxLength: 7,
    },
    TimeEntry: {
        fields: {
            TimeEntryID: 'TimeEntry_TimeEntryID',
            EntryDate: 'TimeEntry_EntryDate',
            Description: 'TimeEntry_Description',
            Billable: 'TimeEntry_Billable',
            Duration: 'TimeEntry_Duration',
            LastModificationDate: 'TimeEntry_LastModificationDate',
            Billed: 'TimeEntry_Billed',
            Approved: 'TimeEntry_Approved',
            Locked: 'TimeEntry_Locked',
            Rate: 'TimeEntry_Rate',
            InternalRate: 'TimeEntry_InternalRate',
            Cost: 'TimeEntry_Cost',
            CreationDate: 'TimeEntry_CreationDate',
        },
        DescriptionMaxLength: 4000,
        DurationMaxValue: 99.99,
        DurationMinValue: 0.01,
    },
    TimeLogWeeklyViewEntity: {
        fields: {
            TaskID: 'TimeLogWeeklyViewEntity_TaskID',
            HoursOnDay0: 'TimeLogWeeklyViewEntity_HoursOnDay0',
            HoursOnDay1: 'TimeLogWeeklyViewEntity_HoursOnDay1',
            HoursOnDay2: 'TimeLogWeeklyViewEntity_HoursOnDay2',
            HoursOnDay3: 'TimeLogWeeklyViewEntity_HoursOnDay3',
            HoursOnDay4: 'TimeLogWeeklyViewEntity_HoursOnDay4',
            HoursOnDay5: 'TimeLogWeeklyViewEntity_HoursOnDay5',
            HoursOnDay6: 'TimeLogWeeklyViewEntity_HoursOnDay6',
            HoursTotal: 'TimeLogWeeklyViewEntity_HoursTotal',
        },
        HoursOnDay0MaxValue: 99.99,
        HoursOnDay0MinValue: 0,
        HoursOnDay1MaxValue: 99.99,
        HoursOnDay1MinValue: 0,
        HoursOnDay2MaxValue: 99.99,
        HoursOnDay2MinValue: 0,
        HoursOnDay3MaxValue: 99.99,
        HoursOnDay3MinValue: 0,
        HoursOnDay4MaxValue: 99.99,
        HoursOnDay4MinValue: 0,
        HoursOnDay5MaxValue: 99.99,
        HoursOnDay5MinValue: 0,
        HoursOnDay6MaxValue: 99.99,
        HoursOnDay6MinValue: 0,
    },
    User: {
        fields: {
            UserID: 'User_UserID',
            Login: 'User_Login',
            Name: 'User_Name',
            Password: 'User_Password',
            EMail: 'User_EMail',
            RecoverConfirmCode: 'User_RecoverConfirmCode',
            Enabled: 'User_Enabled',
            CanLogin: 'User_CanLogin',
            HourlyRate: 'User_HourlyRate',
            HourlyRateInternal: 'User_HourlyRateInternal',
            ShowCompletedTasks: 'User_ShowCompletedTasks',
            ShowCompletedProjects: 'User_ShowCompletedProjects',
            ShowCompletedPortfolios: 'User_ShowCompletedPortfolios',
            ShowAvatars: 'User_ShowAvatars',
            Avatar: 'User_Avatar',
            IsAvatarEmpty: 'User_IsAvatarEmpty',
            AvatarHash: 'User_AvatarHash',
            IsThumbnailAvatar: 'User_IsThumbnailAvatar',
            DefaultPage: 'User_DefaultPage',
            LastActivityDate: 'User_LastActivityDate',
            LoginEnabledDate: 'User_LoginEnabledDate',
            PasswordModifyDate: 'User_PasswordModifyDate',
            InvalidPasswordAttemptsCount: 'User_InvalidPasswordAttemptsCount',
            LastModificationDate: 'User_LastModificationDate',
            LastLockoutDate: 'User_LastLockoutDate',
            PresetID: 'User_PresetID',
            TimeZoneOffset: 'User_TimeZoneOffset',
            CreationDate: 'User_CreationDate',
            IsDistributeHours: 'User_IsDistributeHours',
            IsExpandAssigneeWindow: 'User_IsExpandAssigneeWindow',
            IsAutoFollowEnabled: 'User_IsAutoFollowEnabled',
            PasswordSalt: 'User_PasswordSalt',
            IsWelcomeMailWasSent: 'User_IsWelcomeMailWasSent',
            AuthVersion: 'User_AuthVersion',
            IsPasswordGenerated: 'User_IsPasswordGenerated',
            IsOnboardingPassed: 'User_IsOnboardingPassed',
        },
        LoginMaxLength: 255,
        NameMaxLength: 50,
        PasswordMaxLength: 50,
        EMailMaxLength: 50,
        RecoverConfirmCodeMaxLength: 1000000,
        HourlyRateMaxValue: 99999999,
        HourlyRateMinValue: 0,
        HourlyRateInternalMaxValue: 99999999,
        HourlyRateInternalMinValue: 0,
    },
    JobRole: {
        HourlyRateMaxValue: 99999999,
        HourlyRateMinValue: 0,
        HourlyRateInternalMaxValue: 99999999,
        HourlyRateInternalMinValue: 0,
    },
    UserHourlyRates: {
        fields: {
            UserHourlyRatesID: 'UserHourlyRates_UserHourlyRatesID',
            UserID: 'UserHourlyRates_UserID',
            HourlyRate: 'UserHourlyRates_HourlyRate',
            HourlyRateInternal: 'UserHourlyRates_HourlyRateInternal',
            Date: 'UserHourlyRates_Date',
        },
    },
    UserNotificationEventsView: {
        fields: {
            AccountID: 'UserNotificationEventsView_AccountID',
            NotificationEventID: 'UserNotificationEventsView_NotificationEventID',
            NotificationEventRecipientID: 'UserNotificationEventsView_NotificationEventRecipientID',
            EventRecipientStatus: 'UserNotificationEventsView_EventRecipientStatus',
            EventDate: 'UserNotificationEventsView_EventDate',
            Entity: 'UserNotificationEventsView_Entity',
            ProjectID: 'UserNotificationEventsView_ProjectID',
            TaskID: 'UserNotificationEventsView_TaskID',
            ObjectID: 'UserNotificationEventsView_ObjectID',
            AuthorID: 'UserNotificationEventsView_AuthorID',
            Operation: 'UserNotificationEventsView_Operation',
            ChangeSet: 'UserNotificationEventsView_ChangeSet',
            DeleteSet: 'UserNotificationEventsView_DeleteSet',
            DataSet: 'UserNotificationEventsView_DataSet',
            Template: 'UserNotificationEventsView_Template',
            DigestEvent: 'UserNotificationEventsView_DigestEvent',
            InstantEvent: 'UserNotificationEventsView_InstantEvent',
            DueTasksEvent: 'UserNotificationEventsView_DueTasksEvent',
            LateTasksEvent: 'UserNotificationEventsView_LateTasksEvent',
            WeeklyEvent: 'UserNotificationEventsView_WeeklyEvent',
            LastDigestSendDate: 'UserNotificationEventsView_LastDigestSendDate',
            SendInterval: 'UserNotificationEventsView_SendInterval',
            DueSendInterval: 'UserNotificationEventsView_DueSendInterval',
            NotificationUserOptionID: 'UserNotificationEventsView_NotificationUserOptionID',
            UserTimeZoneOffset: 'UserNotificationEventsView_UserTimeZoneOffset',
            UserEmail: 'UserNotificationEventsView_UserEmail',
        },
    },
    UsersAndTeams: {
        fields: {
            ObjectID: 'UsersAndTeams_ObjectID',
            Name: 'UsersAndTeams_Name',
            IsGroup: 'UsersAndTeams_IsGroup',
            Key: 'UsersAndTeams_Key',
            RoleName: 'UsersAndTeams_RoleName',
            IsGuest: 'UsersAndTeams_IsGuest',
            CustomerId: 'UsersAndTeams_CustomerId',
            RoleID: 'UsersAndTeams_RoleID',
            IsDisabledUser: 'UsersAndTeams_IsDisabledUser',
        },
    },
    UserSchedule: {
        fields: {
            UserScheduleID: 'UserSchedule_UserScheduleID',
            UserID: 'UserSchedule_UserID',
            MondayHours: 'UserSchedule_MondayHours',
            TuesdayHours: 'UserSchedule_TuesdayHours',
            WednesdayHours: 'UserSchedule_WednesdayHours',
            ThursdayHours: 'UserSchedule_ThursdayHours',
            FridayHours: 'UserSchedule_FridayHours',
            SaturdayHours: 'UserSchedule_SaturdayHours',
            SundayHours: 'UserSchedule_SundayHours',
        },
        MondayHoursMaxValue: 99.99,
        MondayHoursMinValue: 0,
        TuesdayHoursMaxValue: 99.99,
        TuesdayHoursMinValue: 0,
        WednesdayHoursMaxValue: 99.99,
        WednesdayHoursMinValue: 0,
        ThursdayHoursMaxValue: 99.99,
        ThursdayHoursMinValue: 0,
        FridayHoursMaxValue: 99.99,
        FridayHoursMinValue: 0,
        SaturdayHoursMaxValue: 99.99,
        SaturdayHoursMinValue: 0,
        SundayHoursMaxValue: 99.99,
        SundayHoursMinValue: 0,
    },
    UserScheduleView: {
        fields: {
            UserID: 'UserScheduleView_UserID',
            RoleID: 'UserScheduleView_RoleID',
            Day: 'UserScheduleView_Day',
            Hours: 'UserScheduleView_Hours',
        },
    },
    UserSkill: {
        fields: {
            UserSkillID: 'UserSkill_UserSkillID',
        },
    },
    UserTeam: {
        fields: {
            UserTeamID: 'UserTeam_UserTeamID',
        },
    },
    Vacation: {
        fields: {
            VacationID: 'Vacation_VacationID',
            Date: 'Vacation_Date',
            IsHalfDay: 'Vacation_IsHalfDay',
        },
    },
    VacationsReportEntity: {
        fields: {
            UserID: 'VacationsReportEntity_UserID',
            UserName: 'VacationsReportEntity_UserName',
            Hours: 'VacationsReportEntity_Hours',
            DateEntry: 'VacationsReportEntity_DateEntry',
            VacationTypeID: 'VacationsReportEntity_VacationTypeID',
            IsHalfDay: 'VacationsReportEntity_IsHalfDay',
        },
    },
    VacationType: {
        fields: {
            VacationTypeID: 'VacationType_VacationTypeID',
            Name: 'VacationType_Name',
            Color: 'VacationType_Color',
            ShortName: 'VacationType_ShortName',
            IsPaid: 'VacationType_IsPaid',
            IncludeInOvertime: 'VacationType_IncludeInOvertime',
        },
        NameMaxLength: 255,
        ColorMaxLength: 7,
        ShortNameMaxLength: 4,
    },
    WorkflowEvent: {
        fields: {
            WorkflowEventID: 'WorkflowEvent_WorkflowEventID',
            WorkflowEventType: 'WorkflowEvent_WorkflowEventType',
            WorkflowEventText: 'WorkflowEvent_WorkflowEventText',
            EventDate: 'WorkflowEvent_EventDate',
            IsSystem: 'WorkflowEvent_IsSystem',
            CreatedAt: 'WorkflowEvent_CreatedAt',
        },
        WorkflowEventTextMaxLength: 1000000,
    },
    WorkflowEventChanges: {
        fields: {
            WorkflowEventChangesID: 'WorkflowEventChanges_WorkflowEventChangesID',
            PropertyName: 'WorkflowEventChanges_PropertyName',
            OldValue: 'WorkflowEventChanges_OldValue',
            NewValue: 'WorkflowEventChanges_NewValue',
            IsCustomField: 'WorkflowEventChanges_IsCustomField',
            FieldDataType: 'WorkflowEventChanges_FieldDataType',
        },
        OldValueMaxLength: 1000000,
        NewValueMaxLength: 1000000,
    },
    UnnamedResource: {
        NameMaxLength: 50,
    },
    // moved the variable from the metadataHelper to make the import work
    // used for input fields of the project name
    // (so that when duplicate does not fall an error that the copy number does not fit)
    // see Bug 38787 - Activity Center -> Duplicate project with max name #1670
    // and Ac_project_creation -> Bugfix#45161 -> No limitation for new project name #4026
    activityNameMaxLength: 250,
    Space: {
        NameMaxLength: 250,
    },
    Invoice: {
        InvoiceNumberMaxLength: 255,
        BillToAddressMaxLength: 255,
        ReferenceMaxLength: 255,
        MemoMaxLength: 4000,
        MessageMaxLength: 4000,
        AddressesMaxLength: 255,
        SubjectMaxLength: 300,
        BodyMaxLength: 4000,
    },
    taxRate: {
        NameMaxLength: 255,
    }
};


export { metadata };

ep = ep || {};
ep.common = ep.common || {};
ep.common.entitiesMetadata = ep.common.entitiesMetadata || {};
ep.common.entitiesMetadata = { ...ep.common.entitiesMetadata, ...metadata };
